<section class="detail-card">
  <h4>Assessment</h4>
  <div class="detail-field">
    <label>Reliability</label>
    <select
      class="form-control state-native-select"
      [ngClass]="getStateClass(collector.reliability)"
      [(ngModel)]="collector.reliability"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="readOnly"
      (ngModelChange)="emitChange()"
    >
      <option *ngFor="let option of config.reliabilityOptions" [value]="option">
        {{ option }}
      </option>
    </select>
  </div>
  <div class="detail-field">
    <label>Engagement</label>
    <select
      class="form-control state-native-select"
      [ngClass]="getEngagementClass(collector.engagement)"
      [ngModel]="collector.engagement"
      [ngModelOptions]="{ standalone: true }"
      disabled
    >
      <option *ngFor="let option of config.engagementOptions" [value]="option">
        {{ option }}
      </option>
    </select>
  </div>
</section>
